// Static imports for all 10 Loading Images (WebP format for ~90% faster load times)
import loadingImg1 from './LoadingImg_1.webp';
import loadingImg2 from './LoadingImg_2.webp';
import loadingImg3 from './LoadingImg_3.webp';
import loadingImg4 from './LoadingImg_4.webp';
import loadingImg5 from './LoadingImg_5.webp';
import loadingImg6 from './LoadingImg_6.webp';
import loadingImg7 from './LoadingImg_7.webp';
import loadingImg8 from './LoadingImg_8.webp';
import loadingImg9 from './LoadingImg_9.webp';
import loadingImg10 from './LoadingImg_10.webp';

export const ALL_10_IMAGES = [
  loadingImg1,
  loadingImg2,
  loadingImg3,
  loadingImg4,
  loadingImg5,
  loadingImg6,
  loadingImg7,
  loadingImg8,
  loadingImg9,
  loadingImg10
];

// Dynamic image loader for all images (supports LoadingImg_1 to LoadingImg_10+)
export const getAvailableImages = () => {
  try {
    const context = require.context('./', false, /\.(webp|png|jpe?g|svg)$/);
    const keys = context.keys().sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, ''), 10) || 0;
      const numB = parseInt(b.replace(/\D/g, ''), 10) || 0;
      return numA - numB;
    });
    if (keys.length > 0) {
      return keys.map(k => context(k)?.default || context(k));
    }
  } catch (e) {
    // Fallback if require.context is unavailable
  }
  return ALL_10_IMAGES;
};

export default getAvailableImages;
